module.exports = __webpack_public_path__ + "img/Platine_0005_6.6bb1312d.png";